<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">{{ $t('COPYRIGHT') }}
      &copy; {{ new Date().getFullYear() }}
      <span class="logo-start">Udara</span><span class="logo-end">360</span>
      <span class="d-none d-sm-inline-block">, {{ $t('All rights Reserved') }} | v{{ packageJson.version }}</span>
    </span>

    <!-- <span class="float-md-right d-none d-md-block">Made with
      <feather-icon
        icon="HeartIcon"
        size="21"
        class="text-danger stroke-current"
      />
      from Nigeria
    </span> -->
    <!-- <span class="float-md-right d-none d-md-block">
      {{ $t('A product of') }}
      <b-link
        class="ml-25"
        href="https://www.fintellia.com"
        target="_blank"
      > Fintellia Technologies Limited</b-link>
    </span> -->
  </p>
</template>

<script>
// import { BLink } from 'bootstrap-vue'
import packageJson from '../../../../package.json'

export default {
  components: {
    // BLink,
  },
  data() {
    return {
      packageJson,
    }
  },
}
</script>

<style lang="scss" scoped>
.logo {
  &-start{
    color: #91C858

  }
  &-end{
    color: #F26333
  }
}
</style>
